<template>
  <section class="flex h-full flex-col justify-between gap-10">
    <div
      role="group"
      aria-label="Location Pills"
      class="flex flex-wrap"
    >
      <div
        v-for="(activity, index) in uniqueActivities"
        :key="index"
        class="mb-2 mr-3 inline-flex items-center justify-center gap-1.5 self-start rounded-full border bg-white px-2 py-1 pt-1.5 text-xs text-dark-gray"
      >
        <span class="text-xs">{{ activity.value }}</span>
        <div class="flex gap-1.5">
          <div class="flex items-center">
            <span
              v-if="activity?.iso_two"
              class="fi"
              style="line-height: 10px !important"
              :class="`fi-${activity?.iso_two?.toLowerCase()}`"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import '../../../node_modules/flag-icons/css/flag-icons.min.css';

const props = defineProps({
  activities: {
    type: Array,
    default: () => [],
  },
});

const uniqueActivities = computed(() => {
  const usActivity = props.activities.find(
    (activity) => activity.us_state_size
  );
  const usStateSize = usActivity?.us_state_size || 0;

  const results = [];
  if (usStateSize > 0) {
    results.push({
      value: `${usStateSize} States`,
      iso_two: 'US',
    });
  }

  const nonUsActivities = props.activities
    .filter((activity) => !activity.us_state_size && activity.value)
    .map((activity) => ({
      value: activity.value,
      iso_two: activity.iso_two,
    }))
    .sort((a, b) => a.value.localeCompare(b.value));

  return results.concat(nonUsActivities);
});
</script>
